export default __webpack_public_path__ + "static/media/account-circle-outline.fcc2589d.svg";